class AmeCarousel extends HTMLElement {
  connectedCallback() {
    this.scroller = this.querySelector('[data-carousel-track]');
    this.previousButton = this.querySelector('[data-carousel-prev]');
    this.nextButton = this.querySelector('[data-carousel-next]');
    if (!this.scroller) return;

    this.previousButton?.addEventListener('click', () => this.move(-1));
    this.nextButton?.addEventListener('click', () => this.move(1));
    this.scroller.addEventListener('scroll', () => this.updateControls(), { passive: true });
    this.scroller.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') this.move(-1);
      if (event.key === 'ArrowRight') this.move(1);
    });

    this.resizeObserver = new ResizeObserver(() => this.updateControls());
    this.resizeObserver.observe(this.scroller);
    this.updateControls();
  }

  disconnectedCallback() {
    this.resizeObserver?.disconnect();
  }

  move(direction) {
    this.scroller?.scrollBy({
      left: direction * this.scroller.clientWidth * 0.85,
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
    });
  }

  updateControls() {
    if (!this.scroller) return;
    const maxScroll = Math.max(0, this.scroller.scrollWidth - this.scroller.clientWidth);
    if (this.previousButton) this.previousButton.disabled = this.scroller.scrollLeft <= 2;
    if (this.nextButton) this.nextButton.disabled = this.scroller.scrollLeft >= maxScroll - 2;
  }
}

if (!customElements.get('ame-carousel')) customElements.define('ame-carousel', AmeCarousel);

let lastOverlayTrigger = null;

function setMobileMenu(button, open) {
  const drawerId = button.getAttribute('aria-controls');
  const drawer = drawerId ? document.getElementById(drawerId) : document.querySelector('[data-mobile-drawer]');
  if (!drawer) return;
  button.setAttribute('aria-expanded', String(open));
  drawer.hidden = !open;
  drawer.classList.toggle('is-open', open);
  if (open) drawer.querySelector('a, summary, button')?.focus();
}

function openCart(trigger) {
  const drawer = document.querySelector('ame-cart-drawer');
  if (!drawer) {
    window.location.href = trigger.getAttribute('href');
    return;
  }
  lastOverlayTrigger = trigger;
  drawer.setAttribute('open', '');
  drawer.setAttribute('aria-hidden', 'false');
  document.body.classList.add('ame-overlay-open');
  drawer.querySelector('[data-close-cart], .ame-cart-drawer__panel')?.focus();
}

function closeCart() {
  const drawer = document.querySelector('ame-cart-drawer');
  if (!drawer) return;
  drawer.removeAttribute('open');
  drawer.setAttribute('aria-hidden', 'true');
  document.body.classList.remove('ame-overlay-open');
  lastOverlayTrigger?.focus();
}

document.addEventListener('click', (event) => {
  const menuButton = event.target.closest('[data-mobile-menu]');
  if (menuButton) {
    setMobileMenu(menuButton, menuButton.getAttribute('aria-expanded') !== 'true');
    return;
  }

  const mobileLink = event.target.closest('[data-mobile-drawer] a');
  if (mobileLink) {
    const drawer = mobileLink.closest('[data-mobile-drawer]');
    const controllingButton = document.querySelector(`[aria-controls="${drawer.id}"]`);
    if (controllingButton) setMobileMenu(controllingButton, false);
  }

  const cartTrigger = event.target.closest('[data-open-cart]');
  if (cartTrigger) {
    event.preventDefault();
    openCart(cartTrigger);
    return;
  }

  if (event.target.closest('[data-close-cart]')) {
    closeCart();
    return;
  }

  const dialogTrigger = event.target.closest('[data-dialog-open], [data-size-guide-open]');
  if (dialogTrigger) {
    const dialog = document.getElementById(dialogTrigger.getAttribute('aria-controls'));
    if (dialog?.showModal) {
      lastOverlayTrigger = dialogTrigger;
      dialog.showModal();
      dialog.querySelector('[data-dialog-close], [data-size-guide-close]')?.focus();
    }
    return;
  }

  const dialogClose = event.target.closest('[data-dialog-close], [data-size-guide-close]');
  if (dialogClose) {
    dialogClose.closest('dialog')?.close();
    lastOverlayTrigger?.focus();
    return;
  }

  if (event.target.matches('.ame-size-guide-dialog')) {
    event.target.close();
    lastOverlayTrigger?.focus();
  }
});

document.addEventListener('close', (event) => {
  if (event.target.matches?.('.ame-size-guide-dialog')) lastOverlayTrigger?.focus();
}, true);

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const openMenuButton = document.querySelector('[data-mobile-menu][aria-expanded="true"]');
  if (openMenuButton) setMobileMenu(openMenuButton, false);
  if (document.querySelector('ame-cart-drawer[open]')) closeCart();
});

document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-variant-select]');
  if (!select) return;
  const form = select.closest('form');
  const option = select.options[select.selectedIndex];
  const available = option?.dataset.available === 'true';
  const addButton = form?.querySelector('[data-atc]');
  if (addButton) {
    addButton.disabled = !available;
    addButton.textContent = available ? (addButton.dataset.atcLabel || 'Add to cart') : (addButton.dataset.soldOutLabel || 'Sold out');
  }
});

function prepareHeroVideos() {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('.ame-hero video').forEach((video) => {
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    if (reducedMotion) {
      video.pause();
      return;
    }
    video.play().catch(() => {
      const startPlayback = () => video.play().catch(() => {});
      document.addEventListener('pointerdown', startPlayback, { once: true, passive: true });
    });
  });
}

prepareHeroVideos();
